import React, { createContext, useContext, useState, useCallback } from 'react';

interface NotificationContextType {
  hasNewVideos: boolean;
  setHasNewVideos: (value: boolean) => void;
  clearNotification: () => void;
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [hasNewVideos, setHasNewVideos] = useState(false);

  const clearNotification = useCallback(() => {
    setHasNewVideos(false);
  }, []);

  return (
    <NotificationContext.Provider value={{ hasNewVideos, setHasNewVideos, clearNotification }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within NotificationProvider');
  }
  return context;
};
